import React, { useState } from "react";
import { Constants } from "../../Utils/Constants";
import ModalDialog from '../../Components/ModalDialog/ModalDialog';

export default function ContactForm() {
    const [name, setName] = useState("");
    const [email, setEmail] = useState("");
    const [message, setMessage] = useState("");
    const [sending, setSending] = useState(false);

    const [showModal, setShowModal] = useState(false);
    const [modalProperties, setModalProperties] = useState({
        handleAcceptButton: function () { setShowModal(false); },
        handleCancelButton: function () { setShowModal(false); },
        acceptButtonText: 'Aceptar',
        showAcceptButton: true,
        showCancelButton: false,
    });

    const showModalDialog = (title, message, type) => {
        setModalProperties((oldState) => ({
            ...oldState,
            title: title,
            message: message,
            type: type
        }));
        setShowModal(true);
    }

    const validate = () => {
        if (!name.trim()) {
            showModalDialog("Error", "Por favor ingresá tu nombre.", Constants.DIALOG_TYPE.ERROR);
            return false;
        }
        if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
            showModalDialog("Error", "Por favor ingresá un email válido.", Constants.DIALOG_TYPE.ERROR);
            return false;
        }
        if (!message.trim()) {
            showModalDialog("Error", "Por favor escribí tu consulta.", Constants.DIALOG_TYPE.ERROR);
            return false;
        }
        return true;
    }

    const sendEmail = () => {
        if (!validate()) return;

        const userId = process.env.REACT_APP_EMAILJS_USERID;
        const templateId = process.env.REACT_APP_EMAILJS_TEMPLATEID;
        const serviceId = process.env.REACT_APP_EMAILJS_SERVICEID || "service_r42x80r";

        setSending(true);

        const templateParams = {
            email,
            name,
            message
        };

        window.emailjs
            .send(
                serviceId,
                templateId,
                templateParams,
                userId
            )
            .then(res => {
                if (res.status === 200) {
                    showModalDialog("Enviado", "Gracias por escribirnos, en breves nuestro equipo se pondrá en contacto con usted.", Constants.DIALOG_TYPE.SUCCESS)
                }
            })
            // Handle errors here however you like
            .catch(err => {
                showModalDialog("Error", "Ocurrió un error. Por favor intente nuevamente más tarde.", Constants.DIALOG_TYPE.ERROR)
            }).finally(() => {
                setSending(false);
            });
    }

    return (
        <div>
            <p className="text-left">Escríbenos tu consulta ...</p>
            <div className="grid grid-cols-2 gap-4">
                <div className="grid grid-cols-1">
                    <p className="pt-3">
                        <label htmlFor="contact-name" className="sr-only">Tu nombre</label>
                        <input id="contact-name" value={name} onChange={(e) => setName(e.target.value)} type="text" placeholder="Tu nombre" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" maxLength="50" aria-required="true" />
                    </p>
                    <p className="pt-3">
                        <label htmlFor="contact-email" className="sr-only">Tu email</label>
                        <input id="contact-email" value={email} onChange={(e) => setEmail(e.target.value)} type="email" placeholder="Tu email" className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline" maxLength="100" aria-required="true" />
                    </p>
                </div>
                <div className="grid grid-cols-1">
                    <p className="pt-3">
                        <label htmlFor="contact-message" className="sr-only">Tu consulta</label>
                        <textarea id="contact-message" value={message} onChange={(e) => setMessage(e.target.value)} rows="4" placeholder="Tu consulta ..." className="shadow appearance-none border rounded w-full py-2 px-3 text-gray-700 leading-tight focus:outline-none focus:shadow-outline resize-none" maxLength="500" aria-required="true"></textarea>
                    </p>
                </div>
                <div className="grid grid-cols-1 justify-left">
                    <button onClick={sendEmail} type="button" className="text-white font-bold py-2 px-6 rounded-lg transition-all duration-200" style={{ background: sending ? '#ccc' : '#ff7a00' }} disabled={sending}>
                        {sending ? 'Enviando...' : 'Enviar'}
                    </button>
                </div>
            </div>
            <ModalDialog {...modalProperties} show={showModal} />
        </div>
    );
}
